import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { MdAdd, MdRemove } from "react-icons/md";
import { Input, FormGroup, Label, Button, Row, Col, Card, CardHeader, CardBody, Table } from 'reactstrap';
import CKEditor from "react-ckeditor-component";
import { getTicketType, getTicketSubType, getAllTicketType } from "../../redux/actions/indexActions";
import { Link } from "react-router-dom";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";

const AddTicketType = ({ placeId }) => {
    const prevPlaceIdRef = useRef();
    const [formData, setFormData] = useState({ type: "", details:"" ,status: 1 });
    const [isEdit, setIsEdit] = useState({
        ticketType:false,
        ticketSubType:false,
        ticketSubSubType:false,
    });
    const [SubType, setSubType] = useState([{ id:"",sub_type:"", sub_type_details:"" }]);
    const [SubSubType, setSubSubType] = useState([{ id:"",sub_sub_type: "", sub_sub_type_details: "" }]);

    const [ticketType, setTicketType] = useState('');
    const [ticketCategory, setTicketCategory] = useState('ticketType');
    const [ticketSubType, setTicketSubType] = useState('');
    const dispatch = useDispatch();
    const [errors, setErrors] = useState({});
    const { auth } = useSelector((state) => state.AuthReducer);
    const inputHandler = (e) => {
        const { name, value, checked, type } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
        }));
    };
    const typeHandler = (e) => {
        const { value } = e.target;
        dispatch(getTicketSubType(auth.token, value));
        setTicketType(value);
    };

    const SubTypeHandler = (e) => {
        const { value } = e.target;
        setTicketSubType(value);
    };
    const { indexReducer: { TicketTypeList, TicketSubTypeList,placeTicketTypes,placeSubTicketTypes,placeSubSubTicketTypes} } = useSelector((state) => state);

    useEffect(() => {
        if (placeId && prevPlaceIdRef.current !== placeId) {
            dispatch(getTicketType(auth.token, placeId));
            dispatch(getAllTicketType(auth.token, placeId));
            prevPlaceIdRef.current = placeId;
        }
    }, [dispatch, auth.token, placeId]);
    
    const addTicketTypeBox = () => {
        console.log('check18')
        setSubType([...SubType, { sub_type: "", sub_type_details: "" }]);
    };
    const inputServiceHandler = (e, index) => {
        console.log('check15')
        const { name, value } = e.target;
        const updatedSubType = [...SubType];
        updatedSubType[index][name] = value;
        setSubType(updatedSubType);
    };

    const handleEditorChange = (content, index, field) => {
        setSubType(prevSubType => {
            const updatedSubType = [...prevSubType];
            updatedSubType[index] = {
                ...updatedSubType[index],
                [field]: content
            };
            return updatedSubType;
        });
    };

    const removeService = (index) => {
        console.log('check11')
        setSubType(SubType.filter((_, i) => i !== index));
    };

    const addSubSubTypeBox = () => {
        const updatedSubType = [...SubSubType];
        updatedSubType.push({ sub_sub_type: "", sub_sub_details: "" });
        setSubSubType(updatedSubType);
    };

    const inputSubSubTypeHandler = (e, subSubIndex) => {
        const { name, value } = e.target;
        const updatedSubType = [...SubSubType];
        updatedSubType[subSubIndex][name] = value;
        setSubSubType(updatedSubType);
    };

    const handleSubSubEditorChange = (content, index, field) => {
        // const updatedSubType = [...SubSubType];
        // updatedSubType[index][field] = content;
        // setSubSubType(updatedSubType);
        setSubSubType(prevSubSubType => {
            const updatedSubSubType = [...prevSubSubType];
            updatedSubSubType[index] = {
                ...updatedSubSubType[index],
                [field]: content
            };
            return updatedSubSubType;
        });
    };

    

    const removeSubSubType = (subSubIndex) => {
        setSubSubType(SubSubType.filter((_, i) => i !== subSubIndex));
    };
    const handleSubmitTicketType = () => {
        // const errors = {};
        if (!placeId) {
            toast.error("Place ID is required.");
            return;
        }
        if (!ticketCategory) {
            toast.error("Ticket Category is required.");
            return;
        }
        if (!formData.type) {
            setErrors({type:"Ticket Type is required."});
            return;
        }

        if (!formData || Object.keys(formData).length === 0) {
            toast.error("Form data is required.");
            return;
        }
        // for (const key in formData) {
        //     if (!formData[key]) {
        //         toast.error(`${key} is required.`);
        //         return;
        //     }
        // }
        const form = new FormData();
        for (const key in formData) {
            form.append(key, formData[key]);
        }
        form.append("place_id", placeId);
        form.append("category", ticketCategory);

        axios.post(`/api/admin/v1/add-ticket-type`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`, 
            },
        })
            .then((res) => {
                setIsEdit(prev =>({
                    ...prev,
                    ticketType:false
                }))
                setErrors({});
                setFormData({ type: "",details:"", status: 1 });
                toast.success(res.data?.message);
                dispatch(getTicketType(auth.token, placeId));
                dispatch(getAllTicketType(auth.token, placeId));
            })
            .catch((err) => {
                if (err.response) {
                    const errorMessage = err.response.data?.message || "An error occurred";
                    toast.error(errorMessage);
                    setErrors(err.response.data);
                } else if (err.request) {
                    toast.error("No response from server. Please check your connection.");
                } else {
                    toast.error("An unexpected error occurred.");
                }
            });
    };

    const handleSubmitSubTicketType = () => {
        const errors = {};
        if (!placeId) errors.placeId = "Place ID is required";
        if (!ticketType) errors.ticketType = "Ticket Type is required";

        if (!formData || Object.keys(formData).length === 0) {
            errors.formData = "Form data cannot be empty";
        }

        if (!SubType || !Array.isArray(SubType) || SubType.length === 0) {
            errors.SubType = "At least one Sub Type is required";
        } else {
            SubType.forEach((sub, index) => {
                if (!sub.sub_type.trim()) {
                    errors[`subType_${index}`] = `Sub Type at index ${index + 1} is required`;
                }

            });
        }
        console.log('handleSubmitSubTicketType',SubType)
        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            Object.values(errors).forEach((error) => toast.error(error));
            return;
        }
        const form = new FormData();
        for (const key in formData) {
            form.append(key, formData[key]);
        }
        form.append("place_id", placeId);
        form.append("ticket_type_id", ticketType);
        form.append("sub_type", JSON.stringify(SubType));
        axios.post(`/api/admin/v1/add-ticket-sub-type`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        })
            .then((res) => {
                setIsEdit(prev =>({
                    ...prev,
                    ticketSubType:false
                }));
                setTicketType("");
                toast.success(res.data?.message);
                dispatch(getAllTicketType(auth.token, placeId));
                dispatch(getTicketSubType(auth.token, ticketType));
                setSubType([{ sub_type: "", sub_type_details: "" }]);
                setErrors({});
            })
            .catch((err) => {
                toast.error(err.response.data?.message || "An error occurred");
                setErrors(err.response.data);
            });
    };

    const handleSubmitSubSubTicketType = () => {
        const errors = {};

        if (!placeId) errors.placeId = "Place ID is required";
        if (!ticketSubType) errors.ticketSubType = "Ticket Sub Type ID is required";

        if (!formData || Object.keys(formData).length === 0) {
            errors.formData = "Form data cannot be empty";
        }

        if (!SubSubType || !Array.isArray(SubSubType) || SubSubType.length === 0) {
            errors.SubSubType = "At least one Sub-Sub Type is required";
        } else {
            SubSubType.forEach((sub, index) => {
                if (!sub.sub_sub_type.trim()) {
                    errors[`subSubType_${index}`] = `Sub-Sub Type at index ${index + 1} is required`;
                }
            });
        }

        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            Object.values(errors).forEach((error) => toast.error(error));
            return;
        }

        const form = new FormData();
        for (const key in formData) {
            form.append(key, formData[key]);
        }
        form.append("place_id", placeId);
        form.append("ticket_sub_type_id", ticketSubType);
        form.append("sub_sub_type", JSON.stringify(SubSubType));

        axios.post(`/api/admin/v1/add-ticket-sub-sub-type`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        })
            .then((res) => {
                setIsEdit(prev =>({
                    ...prev,
                    ticketSubSubType:false
                }));
                setTicketSubType("");
                dispatch(getAllTicketType(auth.token, placeId));
                toast.success(res.data?.message);
                setSubSubType([{ id:"",sub_sub_type: "", sub_sub_type_details: "" }]);
                setErrors({});
            })
            .catch((err) => {
                toast.error(err.response.data?.message || "An error occurred");
                setErrors(err.response.data);
            });
    };
    
    const handleTicketDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete ?")) {
        axios
            .delete(`/api/admin/v1/ticket-type-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllTicketType(auth.token, placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };

    const handleTicketSubDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete ?")) {
        axios
            .delete(`/api/admin/v1/ticket-sub-type-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllTicketType(auth.token, placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };

    const handleTicketSubSubDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete ?")) {
        axios
            .delete(`/api/admin/v1/ticket-sub-sub-type-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllTicketType(auth.token, placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };

    return (
        <div className="container bg-white px-4 py-4">
            <Row>
                <Col md={8}>
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-primary text-white">
                            <h6 className="mb-0">Add Ticket Type</h6>
                        </CardHeader>
                        <CardBody>
                            <FormGroup  className="d-flex align-items-center gap-3 mb-1">
                                <Input
                                    type="text"
                                    name="type"
                                    value={formData.type}
                                    onChange={inputHandler}
                                    invalid={Boolean(errors?.type)}
                                    placeholder="Enter Ticket Type"
                                />
                            </FormGroup>
                            {errors?.type && <span className="text-danger">{errors.type}</span>}
                            <FormGroup>
                                <Label>Details</Label>
                                <CKEditor
                                    activeClass="p10"
                                    content={formData.details || ""}
                                    events={{
                                        change: (e) =>setFormData((prev) => ({
                                            ...prev,
                                            details:e.editor.getData(),
                                        })) 
                                    }}
                                />
                            </FormGroup>
                            {errors?.ticket_type && <span className="text-danger">{errors.ticket_type}</span>}
                            {isEdit.ticketType ? (
                                    <Button color="primary" onClick={handleSubmitTicketType}>Update Type</Button>
                                ):(
                                    <Button color="primary" onClick={handleSubmitTicketType}>Add Type</Button>
                                )}
                        </CardBody>
                    </Card>
                </Col>

            </Row>

            <Row>
                <Col md={6}>
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-secondary text-white">
                            <h6 className="mb-0">Add Ticket Sub Type</h6>
                        </CardHeader>
                        <CardBody>
                            <FormGroup>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <h5 className="mb-0">Sub Type</h5>
                                {isEdit.ticketSubType != true && (
                                <Button className="bg-success text-white" size="sm" onClick={addTicketTypeBox}>
                                    <MdAdd size={22} /> Add Sub Type
                                </Button>
                                )}
                            </div>
                                {/* <Label>Select Ticket Type</Label> */}
                                <Input type="select" name="ticket_type" onChange={typeHandler} value={ticketType}>
                                    <option value="">Select Ticket Type</option>
                                    {TicketTypeList.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.ticket_type}
                                        </option>
                                    ))}
                                </Input>
                                <span className="text-danger">{errors?.tourist_type}</span>
                            </FormGroup>

                            {/* Add Sub Type Section */}
                            

                            {SubType.map((service, subTypeIndex) => (
                                <div className="rounded p-3 my-2 bg-light" key={subTypeIndex}>
                                    <FormGroup>
                                        {/* <Label>Sub Type</Label> */}
                                        <Input
                                            type="text"
                                            name="sub_type"
                                            value={service.sub_type || ""}
                                            onChange={(e) => inputServiceHandler(e, subTypeIndex)}
                                            placeholder="Enter Sub Type"
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Sub Type Details</Label>
                                        <CKEditor
                                            activeClass="p10"
                                            content={service.sub_type_details || ""}
                                            events={{
                                                change: (e) =>
                                                    handleEditorChange(e.editor.getData(), subTypeIndex, 'sub_type_details')
                                            }}
                                        />
                                    </FormGroup>
                                    {isEdit.ticketSubType != true && (
                                        <Button
                                            className="bg-danger text-white"
                                            size="sm"
                                            onClick={() => removeService(subTypeIndex)}
                                        >
                                            <MdRemove size={22} />
                                        </Button>
                                    )}
                                </div>
                            ))}
                            {isEdit.ticketSubType ? (
                                <Button color="primary" onClick={handleSubmitSubTicketType}>Update Sub Type</Button>
                            ):(
                                <Button color="primary" onClick={handleSubmitSubTicketType}>Add Sub Type</Button>
                            )}
                        </CardBody>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-secondary text-white">
                            <h6 className="mb-0">Add Ticket Sub Sub Type</h6>
                        </CardHeader>
                        <CardBody>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <h5 className="mb-0">Sub Sub Type</h5>
                                {isEdit.ticketSubSubType != true && (
                                    <Button className="bg-success text-white" size="sm" onClick={addSubSubTypeBox}>
                                        <MdAdd size={22} /> Add More
                                    </Button>
                                )}
                            </div>

                            <FormGroup>
                                {/* <Label>Select Sub Ticket Type</Label> */}
                                <Input type="select" name="ticket_type" value={ticketSubType} onChange={SubTypeHandler}>
                                    <option value="">Select Ticket Sub Type</option>
                                    {TicketSubTypeList.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.sub_type}
                                        </option>
                                    ))}
                                </Input>
                                <span className="text-danger">{errors?.tourist_type}</span>
                            </FormGroup>

                            {SubSubType.map((service, subSubTypeIndex) => (
                                <div className="rounded p-3 my-2 bg-light" key={subSubTypeIndex}>
                                    <FormGroup>
                                        {/* <Label>Sub Sub Type</Label>  */}
                                        <Input
                                            type="text"
                                            name="sub_sub_type"
                                            value={service.sub_sub_type || ""}
                                            onChange={(e) => inputSubSubTypeHandler(e, subSubTypeIndex)}
                                            placeholder="Enter Sub Sub Type"
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Sub Sub Type Details</Label>
                                        <CKEditor
                                            activeClass="p10"
                                            content={service?.sub_sub_type_details || ""}
                                            events={{
                                                change: (e) =>
                                                    handleSubSubEditorChange(e.editor.getData(), subSubTypeIndex, 'sub_sub_type_details')
                                            }}
                                        />
                                    </FormGroup>
                                    {isEdit.ticketSubSubType != true && (
                                        <Button
                                            className="bg-danger text-white"
                                            size="sm"
                                            onClick={() => removeSubSubType(subSubTypeIndex)}
                                        >
                                            <MdRemove size={22} />
                                        </Button>
                                    )}
                                </div>
                            ))}
                            {isEdit.ticketSubSubType ? (
                                    <Button color="primary" onClick={handleSubmitSubSubTicketType}>Update Sub Sub Type</Button>
                                ):(
                                    <Button color="primary" onClick={handleSubmitSubSubTicketType}>Add Sub Sub Type</Button>
                                )
                            }
                        </CardBody>
                    </Card>
                </Col>
                <Col md={4} className="mt-3">
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-secondary text-white">
                            <h6 className="mb-0">Ticket Type</h6>
                        </CardHeader>
                        <CardBody>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Ticket type</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {placeTicketTypes.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.ticket_type}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <AiOutlineEdit
                                                    size={22}
                                                    className="text-warning me-3"
                                                    onClick={() => {
                                                        setFormData({
                                                            ...formData,
                                                            details: item?.details,
                                                            type: item?.ticket_type,
                                                            id: item?.id,
                                                        });
                                                        setIsEdit(prev =>({
                                                            ...prev,
                                                            ticketType:true
                                                        }));
                                                    }}
                                                    />
                                                <AiOutlineDelete
                                                    size={22}
                                                    className="text-danger"
                                                    onClick={() => handleTicketDel(item.id)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={4} className="mt-3">
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-secondary text-white">
                            <h6 className="mb-0">Ticket Sub Type</h6>
                        </CardHeader>
                        <CardBody>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Ticket type</th>
                                        <th>Ticket Sub Type</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {placeSubTicketTypes.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.ticketType?.ticket_type}</td>
                                        <td>{item?.sub_type}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <AiOutlineEdit
                                                size={22}
                                                className="text-warning me-3"
                                                onClick={()=> {
                                                    setTicketType(item?.ticket_types_id);
                                                    setIsEdit(prev =>({
                                                        ...prev,
                                                        ticketSubType:true
                                                    }));
                                                    setSubType([{
                                                        id: item?.id,
                                                        sub_type: item?.sub_type,
                                                        sub_type_details: item?.sub_type_details,
                                                        ticket_types_id: item?.ticket_types_id,
                                                    }]);
                                                }}
                                                />
                                                <AiOutlineDelete
                                                    size={22}
                                                    className="text-danger"
                                                    onClick={() => handleTicketSubDel(item.id)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={4} className="mt-3">
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-secondary text-white">
                            <h6 className="mb-0">Ticket Sub Sub Type</h6>
                        </CardHeader>
                        <CardBody>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Ticket Sub Type</th>
                                        <th>Ticket Sub Sub Type</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {placeSubSubTicketTypes.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.ticketSubType?.sub_type}</td>
                                        <td>{item?.sub_sub_type}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <AiOutlineEdit
                                                onClick={()=> {
                                                setTicketSubType(item?.sub_types_id);
                                                dispatch(getTicketSubType(auth.token, item?.ticket_sub_type?.ticket_types_id));
                                                    setIsEdit(prev =>({
                                                        ...prev,
                                                        ticketSubSubType:true
                                                    }))
                                                    setSubSubType([{
                                                        id: item?.id,
                                                        sub_sub_type: item?.sub_sub_type,
                                                        sub_sub_type_details: item?.sub_sub_type_details,
                                                        sub_types_id: item?.sub_types_id,
                                                    }]);
                                                }}
                                                size={22}
                                                className="text-warning me-3"
                                                />
                                                <AiOutlineDelete
                                                    size={22}
                                                    className="text-danger"
                                                    onClick={() => handleTicketSubSubDel(item.id)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default AddTicketType;
